module.exports = __webpack_public_path__ + "static/media/new_member_event@3x.efff3c12.webp";